module.exports = "/packs/media/images/logo-blackrock-106e916a6eecc11f792c4f8dfa7f1473.png";